import i18n from 'modules/core/lib/i18n'

export type SalaryErrors = { [key: string]: string }

export const validator = (setErrors: (errors: SalaryErrors) => void) => {
  return (minAmount?: number, maxAmount?: number, grossSalary?: number) => {
    const errors: SalaryErrors = {}

    if (minAmount !== undefined && minAmount < 0) {
      errors['minAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
    }
    if (maxAmount !== undefined && maxAmount < 0) {
      errors['maxAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
    }
    if (grossSalary !== undefined && grossSalary < 0) {
      errors['grossSalary'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
    }
    if (minAmount !== undefined && maxAmount !== undefined && maxAmount < minAmount) {
      errors['maxAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.max_lower_than_min')
    }
    setErrors(errors)
  }
}
